import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import profileImage from '../assets/IMG_2854.JPG';
import { ChevronDown } from 'lucide-react';

const Main = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&display=swap');
          .dm-serif-display-regular {
            font-family: "DM Serif Display", serif;
            font-weight: 400;
            font-style: normal;
          }
        `}
      </style>
      
      <div className="min-h-screen bg-gray-50">
        {/* Mobile Layout - visible on small screens */}
        <div className="block md:hidden px-6 py-8">
          {/* Menu Dropdown */}
          <div className="relative mb-8 flex justify-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="flex items-center space-x-2 text-2xl font-light text-gray-800"
            >
              <span>Menu</span>
              <ChevronDown className={`w-6 h-6 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} />
            </button>
            
            {isMenuOpen && (
              <div className="absolute top-full mt-2 bg-white shadow-lg rounded-lg p-4 z-10 min-w-[200px]">
                <ul className="space-y-3">
                  <li>
                    <Link 
                      to="/projects" 
                      className="block text-lg font-light text-gray-800 hover:underline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      →Projects
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/research" 
                      className="block text-lg font-light text-gray-800 hover:underline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      →Research
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/cv" 
                      className="block text-lg font-light text-gray-800 hover:underline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      →CV
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/contact" 
                      className="block text-lg font-light text-gray-800 hover:underline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      →Contact info
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/socials" 
                      className="block text-lg font-light text-gray-800 hover:underline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      →Socials
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          </div>
          
          {/* Profile Image */}
          <div className="flex justify-center mb-8">
            <img 
              src={profileImage} 
              alt="Roya Arkhmammadova" 
              className="w-64 h-80 object-cover border border-black shadow-lg"
            />
          </div>
          
          {/* Name */}
          <div className="text-center">
            <h1 className="text-4xl dm-serif-display-regular font-light text-gray-800 mb-2">
              Roya
            </h1>
            <h2 className="text-4xl dm-serif-display-regular font-light text-gray-800">
              Arkhmammadova
            </h2>
          </div>
        </div>

        {/* Desktop Layout - hidden on small screens */}
        <div className="hidden md:flex items-center justify-center px-8 py-12 min-h-screen">
          <div className="max-w-7xl w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center lg:pl-16">
              {/* Left side - Profile Image */}
              <div className="flex justify-center lg:justify-start lg:pl-8">
                <img 
                  src={profileImage} 
                  alt="Roya Arkhmammadova" 
                  className="w-64 h-80 object-cover rounded-sm shadow-lg"
                />
              </div>
              
              {/* Right side - Navigation */}
              <div className="flex flex-col items-center lg:items-start text-center lg:text-left lg:pl-20">
                <nav className="mb-12 ml-0 lg:ml-20">
                  <ul className="space-y-2">
                    <li>
                      <Link to="/projects" className="text-xl font-light text-gray-800 hover:underline transition-all">
                        → Projects
                      </Link>
                    </li>
                    <li>
                      <Link to="/research" className="text-xl font-light text-gray-800 hover:underline transition-all">
                        → Research
                      </Link>
                    </li>
                    <li>
                      <Link to="/cv" className="text-xl font-light text-gray-800 hover:underline transition-all">
                        → CV
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="text-xl font-light text-gray-800 hover:underline transition-all">
                        → Contact info
                      </Link>
                    </li>
                    <li>
                      <Link to="/socials" className="text-xl font-light text-gray-800 hover:underline transition-all">
                        → Socials
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            
            {/* Name Section */}
            <div className="text-center">
              <h1 className="text-8xl lg:text-9xl dm-serif-display-regular font-light text-gray-800 tracking-wider">
                ROYA
              </h1>
              <h2 className="text-4xl lg:text-6xl dm-serif-display-regular font-light text-gray-800 tracking-[0.3em] mt-4">
                ARKHMAMMADOVA
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;